import type { MyGradeMatkul } from "@/types";
// Helper untuk menentukan format tampilan nilai

function formatGrade(item: MyGradeMatkul): string {
  return item.nilai ? `${item.nilai}` : `${item.grade}/4`;
}

function template1(data: MyGradeMatkul[], jumlahMatkul: number): string {
  const lines = data.map(
    (d, i) => `${i + 1}. **${d.name}** _(Smt ${d.smtOrdinal})_ — ⭐ **${formatGrade(d)}**`
  );
  const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
  return `Daftar ${teksJumlah}matkul favoritmu berdasarkan nilai terbaik:\n${lines.join('\n')}`;
}

function template2(data: MyGradeMatkul[], jumlahMatkul: number): string {
  const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
  let text = `${teksJumlah}Matkul yang paling kamu suka kayaknya **${data[0].name}** _(Semester ${data[0].smtOrdinal})_, kamu dapat nilai **${formatGrade(data[0])}**!`;

  if (data.length > 1) {
    const rest = data.slice(1, 3).map(
      (d) => `**${d.name}** _(Smt ${d.smtOrdinal} - ${formatGrade(d)})_`
    );
    text += `\n\nMenyusul berikutnya ada ${rest.join(' dan ')}.`;
  }
  return text;
}

function template3(data: MyGradeMatkul[], jumlahMatkul: number): string {
  const lines = data.map(
    (d) => `• **${d.name}** _(Semester ${d.smtOrdinal})_: Nilai **${formatGrade(d)}**`
  );
  const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
  return `Berikut daftar ${teksJumlah}matkul dengan nilai tertinggi yang pernah kamu dapat:\n\n${lines.join('\n\n')}\n\n_Data diambil dari seluruh riwayat penilaianmu._`;
}

function template4(data: MyGradeMatkul[], jumlahMatkul: number): string {
  const lines = data.map(
    (d, i) => `${i + 1}. **${d.name}** — \`Smt ${d.smtOrdinal}\` (⭐ **${formatGrade(d)}**)`
  );
  const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
  return `🏆 **Ini dia ${teksJumlah}matkul favoritmu!**\n${lines.join('\n')}\nKelihatannya kamu cukup sukses dengan pengalaman belajar di matkul-matkul ini! 👍`;
}

function template5(data: MyGradeMatkul[]): string {
  return `🌟 Matkul terbaikmu adalah **${data[0].name}** di _Semester ${data[0].smtOrdinal}_, dengan nilai **${formatGrade(data[0])}**.`;
}

// Fallback jika belum ada data
function templateEmpty(): string {
  return `⚠️ Kamu belum memiliki riwayat nilai mata kuliah apa pun nih.`;
}

export function generateMyBestMatkulResponse(
  data: MyGradeMatkul[],
  jumlahMatkul: number
): string {
  // Edge case: data kosong
  if (!data || data.length === 0) {
    return templateEmpty();
  }

  // Kalau cuma 1 hasil, pakai template khusus single-item
  if (data.length === 1) {
    return template5(data);
  }

  // Kalau lebih dari 1, pilih random dari template yang mendukung list
  const listTemplates = [template1, template2, template3, template4, template5];
  const chosen =
    listTemplates[Math.floor(Math.random() * listTemplates.length)];
  return chosen(data, jumlahMatkul);
}